(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["omni-concierge-bell"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('omni-concierge');
  if (!root) return;
  const launcher = root.querySelector('summary');
  const close = root.querySelector('.omni-concierge__close');
  const dismiss = (restoreFocus) => {
    root.open = false;
    if (restoreFocus) launcher.focus();
  };
  close.addEventListener('click', () => dismiss(true));
  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.open) {
      event.preventDefault();
      event.stopPropagation();
      dismiss(true);
    }
  });
  document.addEventListener('pointerdown', (event) => {
    if (root.open && !root.contains(event.target)) dismiss(false);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
